"use strict";

import Common from "../../Common";
import CommonGame from "../../CommonGame";

export default class ConfirmationPanel extends PIXI.Container {
    constructor() {
        super();

        // Attributes.
        this._bgSprite = null;
        this._messageSprite = null;
        this._messageText = null;
        this._yesBtn = null;
        this._noBtn = null;
        this._selectedBtn = null;

        // Signals.
        this.signals = {};
        this.signals.onYes = new signals.Signal();
        this.signals.onNo = new signals.Signal();
    }

    init() {
        // Background sprite.
        this._bgSprite = new PIXI.Sprite(Common.blankTexture);
        this._bgSprite.anchor = new PIXI.Point(0.5, 0.5);
        this._bgSprite.tint = 0x000000;
        this._bgSprite.alpha = 0.3;
        this._bgSprite.interactive = true;
        this._bgSprite.width = Common.STAGE_WIDTH;
        this._bgSprite.height = Common.STAGE_HEIGHT;
        this.addChild(this._bgSprite);

        // Message sprite.
        this._messageSprite = new PIXI.Sprite(Common.assets.getTexture("colour_palette_big_bg"));
        this._messageSprite.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._messageSprite);

        // Message text.
        this._messageText = P3.createText("COLOUR_IT", {
            size: "64px",
            fill: [0xfff8b3, 0xfac109],
            stroke: 0x006130,
            stokeThickness: 5,
            wordWrap: true,
            wordWrapWidth: this._messageSprite.width - 200
        }, "truetype");

        this._messageText.anchor = new PIXI.Point(0.5, 0.5);
        this._messageText.y = -80;
        this._messageSprite.addChild(this._messageText);

        // Yes button.
        this._yesBtn = createButton("tick", "primary_large");
        this._yesBtn.anchor = new PIXI.Point(0.5, 0.5);
        this._yesBtn.position = new PIXI.Point(100, this._messageSprite.height * 0.5 - 110);
        this._yesBtn.overSoundName = "sfx_ui_rollover_00";
        this._yesBtn.downSoundName = "sfx_ui_click_00";
        this._messageSprite.addChild(this._yesBtn);

        // No button.
        this._noBtn = createButton("cross", "primary_large");
        this._noBtn.anchor = new PIXI.Point(0.5, 0.5);
        this._noBtn.position = new PIXI.Point(-100, this._messageSprite.height * 0.5 - 110);
        this._noBtn.overSoundName = "sfx_ui_rollover_00";
        this._noBtn.downSoundName = "sfx_ui_click_00";
        this._messageSprite.addChild(this._noBtn);

        this.visible = false;
    }

    show(message) {
        this.visible = true;
        this._messageText.text = message;

        this._messageSprite.alpha = 0;
        this._messageSprite.y = -100;
        TweenMax.to(this._messageSprite, 0.25, {y: this._messageSprite.y + 100, alpha: 1, ease: Sine.easeOut});

        this._bgSprite.alpha = 0;
        TweenMax.to(this._bgSprite, 0.25, {alpha: 0.3, ease: Sine.easeOut});

        this._noBtn.alpha = 0;
        this._noBtn.scale = new PIXI.Point();
        TweenMax.to(this._noBtn, 0.25, {alpha: 1, ease: Sine.easeOut, delay: 0.15});
        TweenMax.to(this._noBtn.scale, 0.5, {x: 1, y: 1, ease: Elastic.easeOut, delay: 0.15});

        this._yesBtn.alpha = 0;
        this._yesBtn.scale = new PIXI.Point();
        TweenMax.to(this._yesBtn, 0.25, {alpha: 1, ease: Sine.easeOut, delay: 0.3});
        TweenMax.to(this._yesBtn.scale, 0.5, {x: 1, y: 1, ease: Elastic.easeOut, delay: 0.3});

        // Signals.
        this._yesBtn.signals.click.addOnce(function () {
            this._selectedBtn = this._yesBtn;
            this._hide();
        }, this);
        this._noBtn.signals.click.addOnce(function () {
            this._selectedBtn = this._noBtn;
            this._hide();
        }, this);
    }

    _hide() {
        TweenMax.to(this._messageSprite, 0.25, {y: this._messageSprite.y + 100, alpha: 0, ease: Sine.easeIn});
        TweenMax.to(this._bgSprite, 0.25, {
            alpha: 0,
            ease: Sine.easeIn,
            onComplete: this._onHidden,
            onCompleteScope: this
        });

        // Signals.
        this._yesBtn.signals.click.removeAll();
        this._noBtn.signals.click.removeAll();
    }

    //----EVENTS----//

    _onHidden() {
        if (this._selectedBtn === this._yesBtn) {
            // Sfx.
            //Common.audio.playSound("vo_happo_ok_00");

            this.signals.onYes.dispatch();
        }
        else if (this._selectedBtn === this._noBtn) {
            this.signals.onNo.dispatch();
        }

        this._selectedBtn = null;

        this.visible = false;

        // Signals.
        this.signals.onYes.removeAll();
        this.signals.onNo.removeAll();
    }
}

//===================================================
//
// Constructor
//
//===================================================
/*
 function ConfirmationPanel() {
 PIXI.Container.call(this);


 // Attributes.
 this._bgSprite = null;
 this._messageSprite = null;
 this._messageText = null;
 this._yesBtn = null;
 this._noBtn = null;
 this._selectedBtn = null;


 // Signals.
 this.signals = {};
 this.signals.onYes = new signals.Signal();
 this.signals.onNo = new signals.Signal();
 }

 export default ConfirmationPanel;
 //module.exports = ConfirmationPanel;
 ConfirmationPanel.prototype = Object.create(PIXI.Container.prototype);
 ConfirmationPanel.prototype.constructor = ConfirmationPanel;
 */

//===================================================
//
// Public
//
//===================================================
/*
 ConfirmationPanel.prototype.init = function () {
 // Background sprite.
 this._bgSprite = new PIXI.Sprite(Common.blankTexture);
 this._bgSprite.anchor = new PIXI.Point(0.5, 0.5);
 this._bgSprite.tint = 0x000000;
 this._bgSprite.alpha = 0.3;
 this._bgSprite.interactive = true;
 this._bgSprite.width = Common.STAGE_WIDTH;
 this._bgSprite.height = Common.STAGE_HEIGHT;
 this.addChild(this._bgSprite);

 // Message sprite.
 this._messageSprite = new PIXI.Sprite(Common.assets.getTexture("colour_palette_big_bg"));
 this._messageSprite.anchor = new PIXI.Point(0.5, 0.5);
 this.addChild(this._messageSprite);

 // Message text.
 this._messageText = P3.createText("COLOUR_IT", {
 size: "64px",
 fill: [0xfff8b3, 0xfac109],
 stroke: 0x4c2607,
 stokeThickness: 5,
 wordWrap: true,
 wordWrapWidth: this._messageSprite.width - 200
 }, "truetype");

 this._messageText.anchor = new PIXI.Point(0.5, 0.5);
 this._messageText.y = -80;
 this._messageSprite.addChild(this._messageText);

 // Yes button.
 var btnStatesAux = new P3.ButtonStates(
 Common.assets.getTexture("btn_primary_large_off"),
 Common.assets.getTexture("btn_primary_large_over"),
 Common.assets.getTexture("btn_primary_large_down"),
 Common.assets.getTexture("icon_tick")
 );
 btnStatesAux.iconOver = Common.assets.getTexture("icon_tick");
 btnStatesAux.iconDown = Common.assets.getTexture("icon_tick");
 this._yesBtn = new P3.Button(btnStatesAux);
 this._yesBtn.anchor = new PIXI.Point(0.5, 0.5);
 this._yesBtn.position = new PIXI.Point(100, this._messageSprite.height * 0.5 - 110);
 this._yesBtn.overSoundName = "sfx_ui_rollover_00";
 this._yesBtn.downSoundName = "sfx_ui_click_00";
 this._messageSprite.addChild(this._yesBtn);

 // No button.
 btnStatesAux = new P3.ButtonStates(
 Common.assets.getTexture("btn_primary_large_off"),
 Common.assets.getTexture("btn_primary_large_over"),
 Common.assets.getTexture("btn_primary_large_down"),
 Common.assets.getTexture("icon_cross")
 );
 btnStatesAux.iconOver = Common.assets.getTexture("icon_cross");
 btnStatesAux.iconDown = Common.assets.getTexture("icon_cross");
 this._noBtn = new P3.Button(btnStatesAux);
 this._noBtn.anchor = new PIXI.Point(0.5, 0.5);
 this._noBtn.position = new PIXI.Point(-100, this._messageSprite.height * 0.5 - 110);
 this._noBtn.overSoundName = "sfx_ui_rollover_00";
 this._noBtn.downSoundName = "sfx_ui_click_00";
 this._messageSprite.addChild(this._noBtn);

 this.visible = false;
 };
 */

/*
 ConfirmationPanel.prototype.show = function (message) {
 this.visible = true;
 this._messageText.text = message;

 this._messageSprite.alpha = 0;
 this._messageSprite.y = -100;
 TweenMax.to(this._messageSprite, 0.25, {y: this._messageSprite.y + 100, alpha: 1, ease: Sine.easeOut});

 this._bgSprite.alpha = 0;
 TweenMax.to(this._bgSprite, 0.25, {alpha: 0.3, ease: Sine.easeOut});

 this._noBtn.alpha = 0;
 this._noBtn.scale = new PIXI.Point();
 TweenMax.to(this._noBtn, 0.25, {alpha: 1, ease: Sine.easeOut, delay: 0.15});
 TweenMax.to(this._noBtn.scale, 0.5, {x: 1, y: 1, ease: Elastic.easeOut, delay: 0.15});

 this._yesBtn.alpha = 0;
 this._yesBtn.scale = new PIXI.Point();
 TweenMax.to(this._yesBtn, 0.25, {alpha: 1, ease: Sine.easeOut, delay: 0.3});
 TweenMax.to(this._yesBtn.scale, 0.5, {x: 1, y: 1, ease: Elastic.easeOut, delay: 0.3});


 // Signals.
 this._yesBtn.signals.click.addOnce(function () {
 this._selectedBtn = this._yesBtn;
 this._hide();
 }, this);
 this._noBtn.signals.click.addOnce(function () {
 this._selectedBtn = this._noBtn;
 this._hide();
 }, this);
 };
 */

//===================================================
//
// Private
//
//===================================================
/*
 ConfirmationPanel.prototype._hide = function () {
 TweenMax.to(this._messageSprite, 0.25, {y: this._messageSprite.y + 100, alpha: 0, ease: Sine.easeIn});
 TweenMax.to(this._bgSprite, 0.25, {alpha: 0, ease: Sine.easeIn, onComplete: this._onHidden, onCompleteScope: this});


 // Signals.
 this._yesBtn.signals.click.removeAll();
 this._noBtn.signals.click.removeAll();
 };
 */

//===================================================
//
// Events
//
//===================================================
/*
 ConfirmationPanel.prototype._onHidden = function () {
 if (this._selectedBtn == this._yesBtn) {
 this.signals.onYes.dispatch();

 // Sfx.
 Common.audio.playSound("vo_happo_ok_00");
 }
 else if (this._selectedBtn == this._noBtn)
 this.signals.onNo.dispatch();

 this._selectedBtn = null;

 this.visible = false;

 // Signals.
 this.signals.onYes.removeAll();
 this.signals.onNo.removeAll();
 };
 */
//===================================================
//
// Getters / Setters
//
//===================================================

// TODO: